<template>
    <div class="o-m-map m-map">
        <ODMapController/>
        <MZoomControls />
        <ACompanyInfo
            v-if="isShowExtras"
        />
        <ACompassButton
            v-model="gyroScopeBtnState"
            :rotate="compassDegree"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ACompanyInfo from '../../atoms/a-company-info/a-company-info';
import ACompassButton from '../../atoms/a-compass-button/a-compass-button';
import MZoomControls from '../../molecules/m-zoom-controls/m-zoom-controls';
import ODMapController from "../../organisms/o-d-map-controller/o-d-map-controller";

import {
    SET_GYROSCOPE_STATE,
    TURN_ON_DEVICE_ORIENTATION_EVENTS,
    DISABLE_TOUCH_HORIZONTAL_ROTATION
} from '../../../shared/components/map-viewer/constants/map-commands';

import {
    MOBILE_ROOT,
    MOBILE_GUIDE
} from '../../../utils/constants/pages';

import { NOTIFY_ERROR } from '../../../utils/constants/bus-events-constants';
import {UI_ON_CAMERA_UPDATE} from "../../../shared/components/map-viewer/constants/map-events";

export default {
    name: 'OMMAp',
    components: {
        ACompanyInfo,
        MZoomControls,
        ACompassButton,
        ODMapController
    },
    data() {
        return {
            gyroScopeBtnState: true,
            compassDegree: 0
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        isShowExtras() {
            return this.$route.name.includes(MOBILE_ROOT)
        },
        isMapScreen() {
            return this.$route.name.includes(MOBILE_GUIDE)
        },
        compassCorrectionValue() {
            return this.getMapConfigProp('compass_correction', 0);
        }
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    watch: {
        gyroScopeBtnState: {
            handler(value) {
                if (value) this.modelOrientation();
                else this.compassOrientation();
            },
            immediate: true
        }
    },
    methods: {
        deactivateEventsListeners() {
            this.$bus.$off(UI_ON_CAMERA_UPDATE, this.updateOrientation);
        },
        modelOrientation() {
            window.removeEventListener('deviceorientation', this.addDeviceOrientationListener);
            this.$bus.$on(UI_ON_CAMERA_UPDATE, this.updateOrientation);
            this.$bus.$emit(DISABLE_TOUCH_HORIZONTAL_ROTATION, false);
            this.$bus.$emit(SET_GYROSCOPE_STATE, false);
        },
        updateOrientation() {
            if(document.viewApi)
                this.compassDegree = this.compassCorrectionValue +  document.viewApi.camera_controller.current_orientation
        },
        compassOrientation() {
            this.$bus.$off(UI_ON_CAMERA_UPDATE, this.updateOrientation);
            this.$bus.$emit(SET_GYROSCOPE_STATE, true);
            this.$bus.$emit(DISABLE_TOUCH_HORIZONTAL_ROTATION, true);
            this.$bus.$emit(TURN_ON_DEVICE_ORIENTATION_EVENTS, true);

            // TODO: refactoring

            const IOS = navigator.platform.indexOf('iPhone') !== -1;

            if (IOS) {
                window.DeviceOrientationEvent.requestPermission()
                    .then(response => {
                        if (response === 'granted') {
                            window.addEventListener('deviceorientation', this.addDeviceOrientationListener);
                        }
                    })
                    .catch(e => {
                        this.$bus.$emit(NOTIFY_ERROR, e);
                    })
            } else {
                window.addEventListener('deviceorientation', this.addDeviceOrientationListener);
            }
        },
        addDeviceOrientationListener(event) {
            const IOS = navigator.platform.indexOf('iPhone') !== -1;
            if (IOS) {
                this.compassDegree = 360 - Math.round(event.webkitCompassHeading);
            } else {
                this.compassDegree = Math.round(event.alpha);
            }
        }
    }
}
</script>

<style lang="scss">
@import "o-m-map";
</style>
